var types = {};

types = {
  sing: "Typ",
  plu: "Typen",
  h_plu: "Übersicht - Typen"
}

export default types;